import React from "react";

const ArrowTableDownSvg = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="hidden md:block"
    >
      <title>Sort</title>
      <mask
        id="mask0_4653_19364"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="10"
        height="10"
      >
        <rect
          y="10"
          width="10"
          height="10"
          transform="rotate(-90 0 10)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_4653_19364)">
        <path
          d="M9.16671 3.33333L5.00004 7.5L0.833374 3.33333L1.57296 2.59375L5.00004 6.02083L8.42712 2.59375L9.16671 3.33333Z"
          fill="#D0D4DE"
        />
      </g>
    </svg>
  );
};

export default ArrowTableDownSvg;
